module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-layout-for-china-map-wrap"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._t("main")], 2), _vm._v(" "), _c('div', {
    staticClass: "left-top"
  }, [_vm._t("left-top")], 2), _vm._v(" "), _c('div', {
    staticClass: "right-top"
  }, [_vm._t("right-top")], 2), _vm._v(" "), _c('div', {
    staticClass: "left-bottom"
  }, [_vm._t("left-bottom")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-372d2468!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/china-map-layout/index.vue
// module id = 231
// module chunks = 0